var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',{attrs:{"label-width":"80px","model":_vm.formmodel}},[_c('el-form-item',{attrs:{"label":"页面路径 "}},[_c('el-input',{on:{"input":_vm.changeFunc},model:{value:(_vm.formmodel.url),callback:function ($$v) {_vm.$set(_vm.formmodel, "url", $$v)},expression:"formmodel.url"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8389d692","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/setlink/part/DiyLink.vue
// module id = null
// module chunks = 